import { SendRequest } from "./AxiosUtil";
import LogRocket from "./LogRocketUtil";

let _cachedToken = null;

export const getVideoToken = async () => {
  if (_cachedToken) return _cachedToken;
  try {
    const res = await SendRequest({ method: "GET", url: "api/Games/GetVideoToken" });
    _cachedToken = res.data;
    return _cachedToken;
  } catch (e) {
    console.error("[VideoSDK] Failed to fetch video token:", e);
    return null;
  }
};

export const createMeeting = async () => {
  const token = await getVideoToken();
  if (!token) return { error: "Failed to get video token from server." };
  try {
    const res = await fetch(`https://api.videosdk.live/v2/rooms`, {
      method: "POST",
      headers: {
        authorization: `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    });
    if (!res.ok) {
      let errorMsg = `VideoSDK error (${res.status})`;
      try {
        const errorData = await res.json();
        errorMsg = errorData.message || errorData.error || errorMsg;
      } catch (_) { /* response not JSON */ }
      console.error("[VideoSDK] createMeeting failed:", res.status, errorMsg);
      return { error: errorMsg };
    }
    const data = await res.json();
    LogRocket.log("Created Meeting", data);
    return { roomId: data.roomId || null };
  } catch (e) {
    console.error("[VideoSDK] createMeeting error:", e);
    return { error: e.message || "Network error creating video meeting." };
  }
};

export const getMinutes = async (roomId) => {
  const token = await getVideoToken();
  if (!token) return 0;
  try {
    const res = await fetch(
      `https://api.videosdk.live/v2/sessions?roomId=${roomId}`,
      {
        method: "GET",
        headers: {
          authorization: `${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    const { data } = await res.json();
    console.log("Room Data", data);
    let minutes = 0;
    data.forEach((session) => {
      session.participants.forEach((participant) => {
        participant.timelog.forEach((timelog) => {
          minutes += Math.ceil(
            Math.abs(
              (timelog.end === null ? new Date() : new Date(timelog.end)) -
                new Date(timelog.start)
            ) / 60000.0
          );
        });
      });
    });
    return minutes;
  } catch (e) {
    console.log(e);
    return 0;
  }
};
